import React, { useState, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import './styles/App.css';
import queryString from 'query-string';
import axios from 'axios';
import { instance } from './common';
import parse from 'html-react-parser';

function NoticeDetail({ history, location }) {
  const query = queryString.parse(location.search);
  let n_id = query.n_id;

  const [data, setData] = useState([]);

  let obj = {
    n_id: n_id
  }

  useEffect(() => {

    const fetchData = async () => {
      instance.post('/notice/id', obj).then(function (res) {
        console.log('res.data : ', res.data);
        setData(res.data[0]);
      });
    };

    fetchData();

  }, []);
  console.log('data : ', data)
  let { n_content, n_date, n_title } = data;

  if (n_content) {
    n_content = parse(n_content);
  }
  const goLink = () => {
    history.push('/noticelist');
}
  return (
    <>
      {/* <div className="n_thumbg">
        <span className="n_thumbtext">공지 썸네일</span>
      </div> */}
      <Container className="position-relactive">
        <div className="c_pad">
          <h4 className="mt-5 font-weight-bold">{n_title}</h4>
          <span className="mb-5 d-block no_color">{n_date}</span>
          <div className="s_mbdown">
            <div className="mb-3"></div>
            <div className="w-100 noticeImg">{n_content}</div>
          </div>
          <div className="mb-3"></div>
          <div className="btn btn-primary s_service_btn mb-5" onClick={goLink}>목록</div>
        </div>
      </Container>
    </>
  );
}

export default NoticeDetail;